import * as ExcelJS from "exceljs";

/**
 * Converts an ExcelJS worksheet into an array of JSON objects,
 * using the first row as header keys.
 *
 * This replaces the XLSX.utils.sheet_to_json helper from SheetJS.
 */
export function worksheetToJson<T = Record<string, unknown>>(worksheet: ExcelJS.Worksheet): T[] {
  const results: T[] = [];
  const headers: string[] = [];

  const headerRow = worksheet.getRow(1);
  headerRow.eachCell({ includeEmpty: false }, (cell, colNumber) => {
    headers[colNumber] = String(cell.value ?? "");
  });

  worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    if (rowNumber === 1) return; // skip header row

    const obj: Record<string, unknown> = {};
    row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
      const header = headers[colNumber];
      if (header) {
        obj[header] = cell.value;
      }
    });

    // Only include rows that have at least one value
    if (Object.keys(obj).length > 0) {
      results.push(obj as T);
    }
  });

  return results;
}
